<template>
    <df-app>
        <div class="splash-card centered" v-if="assessment === null"><be-spinner/></div>

        <div class="splash-card centered" v-else-if="assessment === false">
            <be-alert icon-background icon="alert-triangle" color="warning">
                <strong>Assessment nicht gefunden</strong>
                <p>Der eingegebene Code scheint ungültig.<br>Bitte prüfen Sie Ihre Eingabe und versuchen Sie es erneut.</p>
            </be-alert>
        </div>

        <div class="splash-card centered" v-else-if="!assessment.isReportCompleted && !user">
            <be-alert icon-background icon="alert-triangle" color="danger">
                <strong>Assessment in Arbeit</strong>
                <p>Dieses Assessment wurde noch nicht abgeschlossen und kann nur vom zuständigen Coach bearbeitet werden.</p>
                <router-link :to="{ name: 'login', query: { redirect: $route.path } }" class="btn btn-small btn-primary">Anmelden</router-link>
            </be-alert>
        </div>

        <div class="splash-card centered" v-else-if="user && user.id !== assessment.coach.id && !user.isAdmin">
            <be-alert icon-background icon="alert-triangle" color="danger">
                <strong>Zugriff verweigert</strong>
                <p>Sie ({{user.firstname}} {{user.lastname}}) haben keinen Zugriff auf dieses Assessment.</p>
            </be-alert>
        </div>

        <template v-else-if="user">
            <div class="email-head d-none d-md-block d-print-none">
                <div class="email-head-subject">
                    <div class="title">
                        <span class="icon mdi mdi-assignment"></span>&nbsp;
                        <span>{{ assessment.organisationName }} ({{ assessment.readableOrganisationWebsite }})</span>
                        <div class="icons">
                            Erstellt: {{ assessment.readableCreatedAt }}
                            <!--<a href="#"><i class="icon mdi mdi-mail-reply"></i></a>
                            <a href="#"><i class="icon mdi mdi-print"></i></a>
                            <a href="#"><i class="icon mdi mdi-delete"></i></a>-->
                        </div>
                    </div>
                </div>
            </div>

            <nav class="navbar navbar-expand-md be-sub-navigation d-print-none w-100">
                <div class="navbar-collapse be-nav-tabs">
                    <ul class="nav navbar-nav">
                        <router-link class="nav-item" tag="li" :to="{ name: 'assessment' }" exact><a class="nav-link">
                            <i class="icon mdi mdi-assignment-account"></i><span>Übersicht</span>
                        </a></router-link>
                        <router-link class="nav-item" tag="li" :to="{ name: 'assessment_check' }" exact><a class="nav-link">
                            <i class="icon mdi mdi-assignment-o"></i><span>Check</span>
                        </a></router-link>
                        <router-link class="nav-item" tag="li" :to="{ name: 'assessment_survey' }" exact><a class="nav-link">
                            <i class="icon mdi mdi-assignment-alert"></i><span>Assessment</span>
                        </a></router-link>
                        <router-link class="nav-item" tag="li" :to="{ name: 'assessment_report' }" exact><a class="nav-link">
                            <i class="icon mdi mdi-assignment"></i><span>Report</span>
                        </a></router-link>
                    </ul>
                </div>
            </nav>

            <router-view :assessment.sync="assessment"/>
        </template>

        <report :assessment.sync="assessment" v-else/>

    </df-app>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Assessment from '../../models/Assessment';
    import Report from './assessment/Report';

    export default {
        components: { Report },

        data: () => ({
            assessment: null,
            validCoach: null,
        }),

        computed: {
            ...mapGetters('user', ['user']),
        },

        methods: {
            async initialize() {
                this.assessment = null;

                try {
                    this.assessment = await Assessment.find(this.$route.params.id);
                } catch (e) {
                    this.assessment = false;
                }
            },
        },

        watch: {
            $route() {
                if (!this.assessment || this.assessment.id !== this.$route.params.id) {
                    this.initialize();
                }
            },
        },

        mounted() {
            this.initialize();
        },
    };
</script>
